import styled from 'styled-components'

const StyledPhoneInput = styled.div`
  position: relative;
  box-sizing: border-box;

  .PhoneInputCountry {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    z-index: 2;
    padding: ${({ theme }) => theme.space.S4} 0;
  }

  input {
    padding-left: 40px;
  }
`

export default StyledPhoneInput
